module.exports = __webpack_public_path__ + "img/IMG-20200315-WA0048.2ca80566.jpg";